import { removeObjEmptyVal } from 'share/util/helper'
import { service } from '.'
import { errorHandler } from 'share/util/common'

export interface User {
  id: number
  name: string
  acc: string
  role: string
  status: boolean
  phone: string
}
const emptyUser = { id: 0, name: '', acc: '', role: 'ROLE_SENYOUNG', status: true, phone: '' }

class UserStore {
  private _users: User[] = []
  private _user: User = { ...emptyUser }

  get users() {
    return this._users
  }
  get user() {
    return this._user
  }

  loadAll = async () => {
    const res = await service.getUsers()

    if (!res.ok) await errorHandler(res)

    this._users = await res.json()
  }

  loadOne = async (id: number) => {
    if (id === 0) {
      this._user = { ...emptyUser }
      return
    }

    const res = await service.getUser(id)

    if (!res.ok) await errorHandler(res)

    this._user = await res.json()
  }

  save = async (user: User) => {
    const { id, name, acc, role, status, phone } = user
    const basePayload = removeObjEmptyVal({ name, acc, role, phone })

    const res = await (user.id === 0
      ? service.addUser(basePayload)
      : service.updateUser({ ...basePayload, id, status }))

    if (!res.ok) await errorHandler(res)
  }
}

export const userStore = new UserStore()
